// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gJqBQmsErhAvHi {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--ds-border, rgba(9, 30, 66, 0.13));
}
.gJqBQmsErhAvHi p {
  margin: 0;
}
.gJqBQmsErhAvHi .RvLYHJEOwmnDMZ {
  display: flex;
  align-items: center;
}
.gJqBQmsErhAvHi .RvLYHJEOwmnDMZ .HWxJn3sUCD3dxR {
  margin: 0;
  padding-right: 10px;
}
.gJqBQmsErhAvHi .RvLYHJEOwmnDMZ .DffKLTQUwj0BaI {
  display: block;
  z-index: 0;
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 25em;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
  -webkit-user-select: none;
          user-select: none;
}
.gJqBQmsErhAvHi .RvLYHJEOwmnDMZ .DffKLTQUwj0BaI .W3Bn_u9RxA2mlO {
  border-radius: 50%;
}
.gJqBQmsErhAvHi .RvLYHJEOwmnDMZ .Dq6fZRSjtTWgyG .GrmvAISHMi8B_F {
  margin-right: 8px;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
}
.gJqBQmsErhAvHi .RvLYHJEOwmnDMZ .Dq6fZRSjtTWgyG .pGmxbkat8LeIpC {
  color: var(--ds-text-subtle, #44546f);
}
.gJqBQmsErhAvHi .RvLYHJEOwmnDMZ .Dq6fZRSjtTWgyG .pGmxbkat8LeIpC .SqsgNeIh_QTYst {
  margin: 0 4px;
}
.gJqBQmsErhAvHi .blaXCSgmV5rJU5 {
  display: flex;
  align-items: center;
  gap: 12px;
}
.gJqBQmsErhAvHi .blaXCSgmV5rJU5 .kboWlJsxXsTlvH > span {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: 0 -2px 2px 6px;
}
.gJqBQmsErhAvHi .blaXCSgmV5rJU5 .x2w6qin4ZHav8F {
  color: var(--ds-text-subtle, #44546f);
}
.gJqBQmsErhAvHi .blaXCSgmV5rJU5 .JSLQXuESZmd9Xy {
  min-width: 20px;
  min-height: 20px;
}
@media only screen and (max-width: 700px) {
  .gJqBQmsErhAvHi {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guestMemberListItem": `gJqBQmsErhAvHi`,
	"leftSide": `RvLYHJEOwmnDMZ`,
	"checkBox": `HWxJn3sUCD3dxR`,
	"iconBackground": `DffKLTQUwj0BaI`,
	"memberAvatar": `W3Bn_u9RxA2mlO`,
	"details": `Dq6fZRSjtTWgyG`,
	"fullName": `GrmvAISHMi8B_F`,
	"subDetails": `pGmxbkat8LeIpC`,
	"bulletSeparator": `SqsgNeIh_QTYst`,
	"rightSide": `blaXCSgmV5rJU5`,
	"addToWorkspaceButton": `kboWlJsxXsTlvH`,
	"requestWorkspaceAccessDate": `x2w6qin4ZHav8F`,
	"removeButton": `JSLQXuESZmd9Xy`
};
export default ___CSS_LOADER_EXPORT___;
